<template>
  <div class="container">
    <div class="hello">
      <h1>VIDEOS</h1>
      <div class="videos">
        <iframe
          class="video"
          width="800"
          height="450"
          src="https://www.youtube.com/embed/0Vrt632YlmI"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <iframe
          class="video"
          width="800"
          height="450"
          src="https://www.youtube.com/embed/hsvHw9mUxqc"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <iframe
          class="video"
          width="800"
          height="450"
          src="https://www.youtube.com/embed/8W9o7Nh2Ing"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <button class="button">
        <a
          target="_blank"
          href="https://www.youtube.com/channel/UCWn99BkyA2kDDdoyoZs94EQ"
          >See more videos</a
        >
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Videos",
};
</script>

<style scoped>
.container {
  background-image: linear-gradient(black, #1a1310);
}

.subscribe {
  margin-top: -20px;
  color: gray;
}
.hello {
  text-align: center;
  width: auto;
  margin: auto;
  padding: 2% 0;
  color: white;
  overflow: hidden;
}

.videos {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.video {
  max-width: 96%;
  margin-bottom: 10px;
}

.button {
  background-color: #1a1310;
  border-radius: 0;
  border: 2px solid rgba(0, 0, 0, 0.7);
  color: white;
  cursor: pointer;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 700;
  line-height: 18px;
  padding: 6px 32px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  display: block;
  overflow: visible;
  margin: 20px auto;
}
</style>
